"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = void 0;
var activities_1 = require("./activities");
var add_circle_1 = require("./add-circle");
var add_component_1 = require("./add-component");
var alert_1 = require("./alert");
var align_to_bottom_1 = require("./align-to-bottom");
var align_to_center_1 = require("./align-to-center");
var align_to_left_1 = require("./align-to-left");
var align_to_middle_1 = require("./align-to-middle");
var align_to_right_1 = require("./align-to-right");
var align_to_top_1 = require("./align-to-top");
var apple_1 = require("./apple");
var arrow_back_1 = require("./arrow-back");
var arrow_back_circle_1 = require("./arrow-back-circle");
var arrow_down_1 = require("./arrow-down");
var arrow_down_circle_1 = require("./arrow-down-circle");
var arrow_downward_1 = require("./arrow-downward");
var arrow_forward_1 = require("./arrow-forward");
var arrow_forward_circle_1 = require("./arrow-forward-circle");
var arrow_left_1 = require("./arrow-left");
var arrow_right_1 = require("./arrow-right");
var arrow_up_1 = require("./arrow-up");
var arrow_up_circle_1 = require("./arrow-up-circle");
var arrow_upward_1 = require("./arrow-upward");
var attachment_1 = require("./attachment");
var attendee_1 = require("./attendee");
var attending_1 = require("./attending");
var autosave_1 = require("./autosave");
var autosave_disabled_1 = require("./autosave-disabled");
var autosave_saving_1 = require("./autosave-saving");
var billing_1 = require("./billing");
var block_1 = require("./block");
var blur_effect_1 = require("./blur-effect");
var bold_1 = require("./bold");
var bolt_1 = require("./bolt");
var book_1 = require("./book");
var bookmark_1 = require("./bookmark");
var bookmark_outlined_1 = require("./bookmark-outlined");
var booth_1 = require("./booth");
var booth_two_tone_1 = require("./booth-two-tone");
var break_1 = require("./break");
var break_outlined_1 = require("./break-outlined");
var bring_to_front_1 = require("./bring-to-front");
var browser_1 = require("./browser");
var browser_content_1 = require("./browser-content");
var browser_header_1 = require("./browser-header");
var bulb_1 = require("./bulb");
var bullet_list_1 = require("./bullet-list");
var calendar_1 = require("./calendar");
var calendar_add_1 = require("./calendar-add");
var calendar_month_1 = require("./calendar-month");
var calendar_month_two_tone_1 = require("./calendar-month-two-tone");
var calendar_note_1 = require("./calendar-note");
var calendar_note_two_tone_1 = require("./calendar-note-two-tone");
var camera_1 = require("./camera");
var camera_blank_1 = require("./camera-blank");
var camera_off_1 = require("./camera-off");
var caret_down_1 = require("./caret-down");
var caret_left_1 = require("./caret-left");
var caret_right_1 = require("./caret-right");
var caret_up_1 = require("./caret-up");
var chart_bar_1 = require("./chart-bar");
var chart_bar_two_tone_1 = require("./chart-bar-two-tone");
var chart_bubble_1 = require("./chart-bubble");
var chart_line_down_1 = require("./chart-line-down");
var chart_line_up_1 = require("./chart-line-up");
var chart_pie_1 = require("./chart-pie");
var chart_pie_full_1 = require("./chart-pie-full");
var chat_1 = require("./chat");
var chat_heart_1 = require("./chat-heart");
var checkmark_1 = require("./checkmark");
var circle_filled_with_outer_ring_1 = require("./circle-filled-with-outer-ring");
var circle_outlined_1 = require("./circle-outlined");
var clock_1 = require("./clock");
var close_1 = require("./close");
var close_circle_1 = require("./close-circle");
var close_fullscreen_1 = require("./close-fullscreen");
var closed_captions_1 = require("./closed-captions");
var closed_captions_deactivated_1 = require("./closed-captions-deactivated");
var code_1 = require("./code");
var collapse_1 = require("./collapse");
var conditional_1 = require("./conditional");
var contact_agenda_1 = require("./contact-agenda");
var copy_1 = require("./copy");
var custom_text_1 = require("./custom-text");
var dashboard_1 = require("./dashboard");
var date_1 = require("./date");
var delete_1 = require("./delete");
var delete_outlined_1 = require("./delete-outlined");
var desktop_1 = require("./desktop");
var desktop_off_1 = require("./desktop-off");
var disable_1 = require("./disable");
var discover_1 = require("./discover");
var document_1 = require("./document");
var door_closed_1 = require("./door-closed");
var door_open_1 = require("./door-open");
var download_1 = require("./download");
var drag_1 = require("./drag");
var edit_1 = require("./edit");
var email_1 = require("./email");
var email_opened_1 = require("./email-opened");
var email_outlined_1 = require("./email-outlined");
var email_two_tone_1 = require("./email-two-tone");
var emoji_1 = require("./emoji");
var expand_1 = require("./expand");
var facebook_1 = require("./facebook");
var facebook_square_1 = require("./facebook-square");
var favorite_comment_1 = require("./favorite-comment");
var filter_1 = require("./filter");
var flag_half_1 = require("./flag-half");
var fullscreen_enter_1 = require("./fullscreen-enter");
var fullscreen_exit_1 = require("./fullscreen-exit");
var glasses_1 = require("./glasses");
var google_1 = require("./google");
var google_slides_1 = require("./google-slides");
var grid_layout_1 = require("./grid-layout");
var grid_view_1 = require("./grid-view");
var grouped_view_1 = require("./grouped-view");
var guest_info_1 = require("./guest-info");
var hamburger_1 = require("./hamburger");
var hand_1 = require("./hand");
var handshake_1 = require("./handshake");
var heart_1 = require("./heart");
var heart_filled_1 = require("./heart-filled");
var hidden_1 = require("./hidden");
var hopin_1 = require("./hopin");
var house_1 = require("./house");
var image_1 = require("./image");
var image_two_tone_1 = require("./image-two-tone");
var info_circle_1 = require("./info-circle");
var info_list_1 = require("./info-list");
var info_outlined_1 = require("./info-outlined");
var instagram_1 = require("./instagram");
var italic_1 = require("./italic");
var lightning_1 = require("./lightning");
var link_1 = require("./link");
var linkedin_1 = require("./linkedin");
var linkedin_square_1 = require("./linkedin-square");
var list_view_1 = require("./list-view");
var location_pin_1 = require("./location-pin");
var lock_1 = require("./lock");
var mask_1 = require("./mask");
var media_1 = require("./media");
var megaphone_1 = require("./megaphone");
var menu_1 = require("./menu");
var message_1 = require("./message");
var messenger_1 = require("./messenger");
var microphone_1 = require("./microphone");
var microphone_muted_1 = require("./microphone-muted");
var microphone_off_1 = require("./microphone-off");
var minus_1 = require("./minus");
var mobile_1 = require("./mobile");
var move_page_1 = require("./move-page");
var move_users_1 = require("./move-users");
var multi_select_1 = require("./multi-select");
var not_attending_1 = require("./not-attending");
var notification_1 = require("./notification");
var number_list_1 = require("./number-list");
var office_1 = require("./office");
var onsite_1 = require("./onsite");
var open_in_full_1 = require("./open-in-full");
var open_in_new_1 = require("./open-in-new");
var option_1 = require("./option");
var outlook_1 = require("./outlook");
var overlay_1 = require("./overlay");
var paragraph_text_1 = require("./paragraph-text");
var pause_1 = require("./pause");
var people_1 = require("./people");
var pin_1 = require("./pin");
var play_1 = require("./play");
var plug_1 = require("./plug");
var plus_1 = require("./plus");
var publish_1 = require("./publish");
var q_and_a_1 = require("./q-and-a");
var qr_code_1 = require("./qr-code");
var question_bubble_1 = require("./question-bubble");
var question_mark_1 = require("./question-mark");
var question_mark_fill_1 = require("./question-mark-fill");
var redo_1 = require("./redo");
var refresh_1 = require("./refresh");
var reload_1 = require("./reload");
var remove_1 = require("./remove");
var report_1 = require("./report");
var revert_1 = require("./revert");
var rocket_1 = require("./rocket");
var scissors_1 = require("./scissors");
var search_1 = require("./search");
var security_on_1 = require("./security-on");
var send_1 = require("./send");
var send_filled_1 = require("./send-filled");
var send_to_back_1 = require("./send-to-back");
var sessions_1 = require("./sessions");
var settings_1 = require("./settings");
var share_1 = require("./share");
var shuffle_1 = require("./shuffle");
var sign_in_1 = require("./sign-in");
var sign_out_1 = require("./sign-out");
var signal_1 = require("./signal");
var single_line_text_1 = require("./single-line-text");
var single_select_1 = require("./single-select");
var smile_1 = require("./smile");
var speaker_1 = require("./speaker");
var square_outlined_1 = require("./square-outlined");
var sso_1 = require("./sso");
var star_1 = require("./star");
var stars_1 = require("./stars");
var stopwatch_1 = require("./stopwatch");
var strikethrough_1 = require("./strikethrough");
var success_1 = require("./success");
var support_1 = require("./support");
var tablet_1 = require("./tablet");
var team_1 = require("./team");
var text_1 = require("./text");
var text_center_1 = require("./text-center");
var text_left_1 = require("./text-left");
var text_right_1 = require("./text-right");
var thumbs_up_1 = require("./thumbs-up");
var ticket_1 = require("./ticket");
var tile_view_1 = require("./tile-view");
var tile_view_filled_1 = require("./tile-view-filled");
var twitter_1 = require("./twitter");
var underline_1 = require("./underline");
var undo_1 = require("./undo");
var unlock_1 = require("./unlock");
var unpin_1 = require("./unpin");
var user_1 = require("./user");
var users_1 = require("./users");
var users_group_1 = require("./users-group");
var venue_1 = require("./venue");
var video_gallery_1 = require("./video-gallery");
var voice_record_1 = require("./voice-record");
var wallet_1 = require("./wallet");
var wand_1 = require("./wand");
var warning_1 = require("./warning");
var watching_1 = require("./watching");
var watching_off_1 = require("./watching-off");
var waveform_1 = require("./waveform");
var website_1 = require("./website");
var whatsapp_1 = require("./whatsapp");
var wrench_1 = require("./wrench");
// All keys are wrapped in quotes for easier programmatic sorting
// prettier-ignore
exports.icons = {
    'activities': activities_1.Activities,
    'add-circle': add_circle_1.AddCircle,
    'add-component': add_component_1.AddComponent,
    'alert': alert_1.Alert,
    'align-to-bottom': align_to_bottom_1.AlignToBottom,
    'align-to-center': align_to_center_1.AlignToCenter,
    'align-to-left': align_to_left_1.AlignToLeft,
    'align-to-middle': align_to_middle_1.AlignToMiddle,
    'align-to-right': align_to_right_1.AlignToRight,
    'align-to-top': align_to_top_1.AlignToTop,
    'apple': apple_1.Apple,
    'arrow-back': arrow_back_1.ArrowBack,
    'arrow-back-circle': arrow_back_circle_1.ArrowBackCircle,
    'arrow-down': arrow_down_1.ArrowDown,
    'arrow-down-circle': arrow_down_circle_1.ArrowDownCircle,
    'arrow-downward': arrow_downward_1.ArrowDownward,
    'arrow-forward': arrow_forward_1.ArrowForward,
    'arrow-forward-circle': arrow_forward_circle_1.ArrowForwardCircle,
    'arrow-left': arrow_left_1.ArrowLeft,
    'arrow-right': arrow_right_1.ArrowRight,
    'arrow-up': arrow_up_1.ArrowUp,
    'arrow-up-circle': arrow_up_circle_1.ArrowUpCircle,
    'arrow-upward': arrow_upward_1.ArrowUpward,
    'attachment': attachment_1.Attachment,
    'attendee': attendee_1.Attendee,
    'attending': attending_1.Attending,
    'autosave': autosave_1.Autosave,
    'autosave-disabled': autosave_disabled_1.AutosaveDisabled,
    'autosave-saving': autosave_saving_1.AutosaveSaving,
    'billing': billing_1.Billing,
    'block': block_1.Block,
    'blur-effect': blur_effect_1.BlurEffect,
    'bold': bold_1.Bold,
    'bolt': bolt_1.Bolt,
    'book': book_1.Book,
    'bookmark': bookmark_1.Bookmark,
    'bookmark-outlined': bookmark_outlined_1.BookmarkOutlined,
    'booth': booth_1.Booth,
    'booth-two-tone': booth_two_tone_1.BoothTwoTone,
    'break': break_1.Break,
    'break-outlined': break_outlined_1.BreakOutlined,
    'bring-to-front': bring_to_front_1.BringToFront,
    'browser': browser_1.Browser,
    'browser-content': browser_content_1.BrowserContent,
    'browser-header': browser_header_1.BrowserHeader,
    'bulb': bulb_1.Bulb,
    'bullet-list': bullet_list_1.BulletList,
    'calendar': calendar_1.Calendar,
    'calendar-add': calendar_add_1.CalendarAdd,
    'calendar-month': calendar_month_1.CalendarMonth,
    'calendar-month-two-tone': calendar_month_two_tone_1.CalendarMonthTwoTone,
    'calendar-note': calendar_note_1.CalendarNote,
    'calendar-note-two-tone': calendar_note_two_tone_1.CalendarNoteTwoTone,
    'camera': camera_1.Camera,
    'camera-blank': camera_blank_1.CameraBlank,
    'camera-off': camera_off_1.CameraOff,
    'caret-down': caret_down_1.CaretDown,
    'caret-left': caret_left_1.CaretLeft,
    'caret-right': caret_right_1.CaretRight,
    'caret-up': caret_up_1.CaretUp,
    'chart-bar': chart_bar_1.ChartBar,
    'chart-bar-two-tone': chart_bar_two_tone_1.ChartBarTwoTone,
    'chart-bubble': chart_bubble_1.ChartBubble,
    'chart-line-down': chart_line_down_1.ChartLineDown,
    'chart-line-up': chart_line_up_1.ChartLineUp,
    'chart-pie': chart_pie_1.ChartPie,
    'chart-pie-full': chart_pie_full_1.ChartPieFull,
    'chat': chat_1.Chat,
    'chat-heart': chat_heart_1.ChatHeart,
    'checkmark': checkmark_1.Checkmark,
    'circle-filled-with-outer-ring': circle_filled_with_outer_ring_1.CircleFilledWithOuterRing,
    'circle-outlined': circle_outlined_1.CircleOutlined,
    'clock': clock_1.Clock,
    'close': close_1.Close,
    'close-circle': close_circle_1.CloseCircle,
    'closed-captions': closed_captions_1.ClosedCaptions,
    'closed-captions-deactivated': closed_captions_deactivated_1.ClosedCaptionsDeactivated,
    'close-fullscreen': close_fullscreen_1.CloseFullscreen,
    'code': code_1.Code,
    'collapse': collapse_1.Collapse,
    'conditional': conditional_1.Conditional,
    'contact-agenda': contact_agenda_1.ContactAgenda,
    'copy': copy_1.Copy,
    'custom-text': custom_text_1.CustomText,
    'dashboard': dashboard_1.Dashboard,
    'date': date_1.Date,
    'delete': delete_1.Delete,
    'delete-outlined': delete_outlined_1.DeleteOutlined,
    'desktop': desktop_1.Desktop,
    'desktop-off': desktop_off_1.DesktopOff,
    'disable': disable_1.Disable,
    'discover': discover_1.Discover,
    'document': document_1.Document,
    'door-closed': door_closed_1.DoorClosed,
    'door-open': door_open_1.DoorOpen,
    'download': download_1.Download,
    'drag': drag_1.Drag,
    'edit': edit_1.Edit,
    'email': email_1.Email,
    'email-opened': email_opened_1.EmailOpened,
    'email-outlined': email_outlined_1.EmailOutlined,
    'email-two-tone': email_two_tone_1.EmailTwoTone,
    'emoji': emoji_1.Emoji,
    'expand': expand_1.Expand,
    'facebook': facebook_1.Facebook,
    'facebook-square': facebook_square_1.FacebookSquare,
    'favorite-comment': favorite_comment_1.FavoriteComment,
    'filter': filter_1.Filter,
    'flag-half': flag_half_1.FlagHalf,
    'fullscreen-enter': fullscreen_enter_1.FullscreenEnter,
    'fullscreen-exit': fullscreen_exit_1.FullscreenExit,
    'glasses': glasses_1.Glasses,
    'google': google_1.Google,
    'google-slides': google_slides_1.GoogleSlides,
    'grid-layout': grid_layout_1.GridLayout,
    'grid-view': grid_view_1.GridView,
    'grouped-view': grouped_view_1.GroupedView,
    'guest-info': guest_info_1.GuestInfo,
    'hamburger': hamburger_1.Hamburger,
    'hand': hand_1.Hand,
    'handshake': handshake_1.Handshake,
    'heart': heart_1.Heart,
    'heart-filled': heart_filled_1.HeartFilled,
    'hidden': hidden_1.Hidden,
    'hopin': hopin_1.Hopin,
    'house': house_1.House,
    'image': image_1.Image,
    'image-two-tone': image_two_tone_1.ImageTwoTone,
    'info-circle': info_circle_1.InfoCircle,
    'info-list': info_list_1.InfoList,
    'info-outlined': info_outlined_1.InfoOutlined,
    'instagram': instagram_1.Instagram,
    'italic': italic_1.Italic,
    'lightning': lightning_1.Lightning,
    'link': link_1.Link,
    'linkedin': linkedin_1.LinkedIn,
    'linkedin-square': linkedin_square_1.LinkedInSquare,
    'list-view': list_view_1.ListView,
    'lock': lock_1.Lock,
    'location-pin': location_pin_1.LocationPin,
    'mask': mask_1.Mask,
    'media': media_1.Media,
    'megaphone': megaphone_1.Megaphone,
    'menu': menu_1.Menu,
    'message': message_1.Message,
    'messenger': messenger_1.Messenger,
    'microphone': microphone_1.Microphone,
    'microphone-muted': microphone_muted_1.MicrophoneMuted,
    'microphone-off': microphone_off_1.MicrophoneOff,
    'minus': minus_1.Minus,
    'mobile': mobile_1.Mobile,
    'move-page': move_page_1.MovePage,
    'move-users': move_users_1.MoveUsers,
    'multi-select': multi_select_1.MultiSelect,
    'not-attending': not_attending_1.NotAttending,
    'notification': notification_1.Notification,
    'number-list': number_list_1.NumberList,
    'office': office_1.Office,
    'onsite': onsite_1.Onsite,
    'open-in-full': open_in_full_1.OpenInFull,
    'open-in-new': open_in_new_1.OpenInNew,
    'option': option_1.Option,
    'outlook': outlook_1.Outlook,
    'overlay': overlay_1.Overlay,
    'paragraph-text': paragraph_text_1.ParagraphText,
    'pause': pause_1.Pause,
    'people': people_1.People,
    'pin': pin_1.Pin,
    'play': play_1.Play,
    'plug': plug_1.Plug,
    'plus': plus_1.Plus,
    'publish': publish_1.Publish,
    'q-and-a': q_and_a_1.QandA,
    'qr-code': qr_code_1.QrCode,
    'question-bubble': question_bubble_1.QuestionBubble,
    'question-mark': question_mark_1.QuestionMark,
    'question-mark-fill': question_mark_fill_1.QuestionMarkFill,
    'redo': redo_1.Redo,
    'refresh': refresh_1.Refresh,
    'reload': reload_1.Reload,
    'remove': remove_1.Remove,
    'report': report_1.Report,
    'revert': revert_1.Revert,
    'rocket': rocket_1.Rocket,
    'scissors': scissors_1.Scissors,
    'search': search_1.Search,
    'security-on': security_on_1.SecurityOn,
    'send': send_1.Send,
    'send-filled': send_filled_1.SendFilled,
    'send-to-back': send_to_back_1.SendToBack,
    'sessions': sessions_1.Sessions,
    'settings': settings_1.Settings,
    'share': share_1.Share,
    'shuffle': shuffle_1.Shuffle,
    'sign-in': sign_in_1.SignIn,
    'sign-out': sign_out_1.SignOut,
    'signal': signal_1.Signal,
    'single-line-text': single_line_text_1.SingleLineText,
    'single-select': single_select_1.SingleSelect,
    'smile': smile_1.Smile,
    'speaker': speaker_1.Speaker,
    'square-outlined': square_outlined_1.SquareOutlined,
    'sso': sso_1.SSO,
    'star': star_1.Star,
    'stars': stars_1.Stars,
    'stopwatch': stopwatch_1.Stopwatch,
    'strikethrough': strikethrough_1.Strikethrough,
    'success': success_1.Success,
    'support': support_1.Support,
    'tablet': tablet_1.Tablet,
    'team': team_1.Team,
    'text': text_1.Text,
    'text-center': text_center_1.TextCenter,
    'text-left': text_left_1.TextLeft,
    'text-right': text_right_1.TextRight,
    'thumbs-up': thumbs_up_1.ThumbsUp,
    'ticket': ticket_1.Ticket,
    'tile-view': tile_view_1.TileView,
    'tile-view-filled': tile_view_filled_1.TileViewFilled,
    'twitter': twitter_1.Twitter,
    'underline': underline_1.Underline,
    'undo': undo_1.Undo,
    'unlock': unlock_1.Unlock,
    'unpin': unpin_1.Unpin,
    'user': user_1.User,
    'users': users_1.Users,
    'users-group': users_group_1.UsersGroup,
    'venue': venue_1.Venue,
    'video-gallery': video_gallery_1.VideoGallery,
    'voice-record': voice_record_1.VoiceRecord,
    'wallet': wallet_1.Wallet,
    'wand': wand_1.Wand,
    'warning': warning_1.Warning,
    'watching': watching_1.Watching,
    'watching-off': watching_off_1.WatchingOff,
    'waveform': waveform_1.Waveform,
    'website': website_1.Website,
    'whatsapp': whatsapp_1.Whatsapp,
    'wrench': wrench_1.Wrench
};
//# sourceMappingURL=index.js.map